import type { BadgeSize } from '../../components/Badge/Badge';
import type { ControlSize } from './types';
import { devices } from '../../common/devices';
import { variantAccentColor } from '../../common/variant';

export const controlHeight = '$$controlHeight';
export const controlBorderRadius = '$$controlBorderRadius';
export const controlGap = '$$controlGap';
export const controlPaddingX = '$$controlPaddingX';
export const controlPaddingY = '$$controlPaddingY';
export const controlIconSize = '$$controlIconSize';
export const controlArrowsSize = '$$controlArrowsSize';
export const controlLoadingSize = '$$controlLoadingSize';
export const variantHeadingColor = '$$variantHeadingColor';
export const controlBodyColor = '$$controlBodyColor';
export const controlIconColor = '$$controlIconColor';
export const controlTextDecoration = '$$controlTextDecoration';
export const controlTextDecorationValue = `underline dotted 2px ${variantAccentColor}`;

export const controlVars = {
  size: {
    'x-small': {
      [controlHeight]: '$space$20',
      [controlBorderRadius]: '$space$6',
      [controlGap]: '$space$2',
      [controlPaddingX]: '$space$4',
      [controlPaddingY]: '$space$2',
      [controlIconSize]: '$space$12',
      [controlArrowsSize]: '$space$10',
      [controlLoadingSize]: '$space$14',
    },
    small: {
      [devices.touch]: {
        [controlHeight]: '$space$28',
        [controlBorderRadius]: '$space$10',
        [controlGap]: '$space$6',
        [controlPaddingX]: '$space$8',
        [controlPaddingY]: '$space$2',
        [controlIconSize]: '$space$14',
        [controlArrowsSize]: '$space$12',
        [controlLoadingSize]: '$space$16',
      },

      [devices.mouse]: {
        [controlHeight]: '$space$24',
        [controlBorderRadius]: '$space$8',
        [controlGap]: '$space$4',
        [controlPaddingX]: '$space$6',
        [controlPaddingY]: '$space$2',
        [controlIconSize]: '$space$12',
        [controlArrowsSize]: '$space$10',
        [controlLoadingSize]: '$space$14',
      },
    },
    medium: {
      [devices.touch]: {
        [controlHeight]: '$space$32',
        [controlBorderRadius]: '$space$10',
        [controlGap]: '$space$6',
        [controlPaddingX]: '$space$10',
        [controlPaddingY]: '$space$4',
        [controlIconSize]: '$space$14',
        [controlArrowsSize]: '$space$12',
        [controlLoadingSize]: '$space$16',
      },

      [devices.mouse]: {
        [controlHeight]: '$space$28',
        [controlBorderRadius]: '$space$8',
        [controlGap]: '$space$4',
        [controlPaddingX]: '$space$8',
        [controlPaddingY]: '$space$4',
        [controlIconSize]: '$space$12',
        [controlArrowsSize]: '$space$10',
        [controlLoadingSize]: '$space$14',
      },
    },
    large: {
      [controlHeight]: '$space$36',
      [controlBorderRadius]: '$space$10',
      [controlGap]: '$space$6',
      [controlPaddingX]: '$space$12',
      [controlPaddingY]: '$space$4',
      [controlIconSize]: '$space$14',
      [controlArrowsSize]: '$space$12',
      [controlLoadingSize]: '$space$14',
    },
    'x-large': {
      [controlHeight]: '$space$44',
      [controlBorderRadius]: '$space$12',
      [controlGap]: '$space$8',
      [controlPaddingX]: '$space$20',
      [controlPaddingY]: '$space$6',
      [controlIconSize]: '$space$14',
      [controlArrowsSize]: '$space$12',
      [controlLoadingSize]: '$space$14',
    },
  },
};

export function getControlPreset(size: ControlSize) {
  switch (size) {
    case 'x-small':
    case 'small':
      return 'small';
    case 'large':
    case 'x-large':
      return 'large';
    case 'medium':
    default:
      return 'body';
  }
}

export function getControlIconSize(size: ControlSize) {
  switch (size) {
    case 'large':
    case 'x-large':
      return 14;
    case 'x-small':
    case 'small':
    case 'medium':
    default:
      return 12;
  }
}

export function getControlSubcontrolSize(size: ControlSize): ControlSize {
  switch (size) {
    case 'x-small':
    case 'small':
      return 'x-small';
    case 'large':
      return 'medium';
    case 'x-large':
      return 'large';
    case 'medium':
    default:
      return 'small';
  }
}

export function getControlBadgeSize(size: ControlSize): BadgeSize {
  if (size === 'x-small') return 'x-small';
  if (size === 'small') return 'small';
  return 'medium';
}
